export default __webpack_public_path__ + "ff53c3b44421edd46506f5b35cf56b2f.svg";